import $ from "jquery";

export default class TextSection {
  $el = $("section.text-section");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.exampleFunction();
  }

  exampleFunction() {
    const $counter = this.$el.find(".js-text-section__content");

    $counter.on("click", function () {
      $(this).toggleClass("active");
      $(this).find(".text-section-button").toggleClass("active");
    });
  }
}
